import { SelectCard, Text } from '@servicetitan/anvil2';
import { Controller, get, useFormContext } from 'react-hook-form';

export interface SelectCardOption {
    id: string | number;
    label: string;
    description?: string;
}

export interface SelectCardGroupProps {
    name: string;
    options: SelectCardOption[];
    legend: string;
    required?: boolean;
}

export const SelectCardGroup = ({ name, options, legend, required }: SelectCardGroupProps) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = get(errors, name);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <div>
                    <SelectCard.Group
                        legend={legend}
                        selectionMode="single"
                        showSelectIndicator
                        required={required}
                        onChange={(
                            _e: unknown,
                            state: { checked: boolean; id?: string | number } | undefined,
                        ) => {
                            if (state?.checked && state?.id != null) {
                                field.onChange(state.id);
                            }
                        }}
                    >
                        {options.map(option => (
                            <SelectCard
                                key={option.id}
                                id={option.id}
                                checked={field.value === option.id}
                                showSelectIndicator
                            >
                                <Text variant="headline" size="small" el="h3">
                                    {option.label}
                                </Text>
                                {option.description && <Text>{option.description}</Text>}
                            </SelectCard>
                        ))}
                    </SelectCard.Group>
                    {error?.message && (
                        <Text color="negative" size="small">
                            {error.message}
                        </Text>
                    )}
                </div>
            )}
        />
    );
};
